import React from 'react'
import {ProjectItem} from './projectItem'
import { projectsList } from './mock';
export const Projects = () => {
    return (
        <div className="projects">
            <ul>
                {projectsList.map((item,i)=>(
                   <ProjectItem key={'projects'+i} item={item} />
                ))}
            </ul>
            <div className="button"><p> Load more</p></div>
        </div>
    )

}
 